import _ from 'lodash';
import { getUser } from '~src/user';
import { addCanvasImage } from '~core/image';
import { generateObjRefId } from '~core';
import { getState, modifyState } from '~src/state';
import {
  getObjectCenterCoordinates,
  changeImageSrc,
  getImageDimensionsFromUrl,
} from '~src/utils';
import { isLoggedUserGlobalEditor } from '~src/user';
import { EdgeResizer } from '~src/utils';

const allowedLogoTypes = ['logo', 'logo_completo'];

export const addCanvasBusinessLogo = async (logoType = 'logo') => {
  if (!allowedLogoTypes.includes(logoType)) {
    throw new Error('Invalid logo type');
  }
  const { user } = await getUser();

  const logoUrl = _.get(user, `org_pointer.${logoType}.url`);

  const options = {
    giotto: {
      objRefId: generateObjRefId('logo'),
      logo: true,
      logoType,
    },
  };

  await addCanvasImage(logoUrl, options);
};

export const fetchLogos = async (forceFetch = false) => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();

  const cachedLogos = getState('sidebarLogos');

  if (cachedLogos && !forceFetch) {
    return cachedLogos;
  }
  const logos = [];

  if (isGlobalEditor) {
    const logoPlaceholderUrl = `${process.env.OFC_CDN_URL}/logos/ofc_blu.png`;

    logos.push({ logoType: 'logo', url: logoPlaceholderUrl });
    logos.push({ logoType: 'logo_completo', url: logoPlaceholderUrl });
  } else {
    const { user } = await getUser({}, forceFetch);
    const logoUrl = _.get(user, 'org_pointer.logo.url');
    const logoCompletoUrl = _.get(user, 'org_pointer.logo_completo.url');

    if (logoUrl) {
      logos.push({
        logoType: 'logo',
        url: logoUrl,
      });
    }

    if (logoCompletoUrl) {
      logos.push({
        logoType: 'logo_completo',
        url: logoCompletoUrl,
      });
    }
  }

  for (const logo of logos) {
    try {
      const { width, height } = await getImageDimensionsFromUrl(logo.url);
      logo.width = width;
      logo.height = height;
    } catch (err) {
      console.error('Cannot fetch logos. Width and Height not available');
    }
  }

  modifyState('sidebarLogos', {
    items: logos,
    allowNew: true,
  });

  return {
    items: logos,
    allowNew: true,
  };
};

export const applyOrgLogosOnCurrentPage = async () => {
  const sidebarLogos = await fetchLogos();

  const objects = window.canvas.getObjects();

  for (const obj of objects) {
    const isLogo = _.get(obj, 'giotto.logo', false);

    if (isLogo) {
      const logoType = _.get(obj, 'giotto.logoType', 'logo');
      const findReplacementLogo = sidebarLogos.items.find((logo) => {
        if (logo.logoType === logoType) {
          return logo;
        }
      });

      if (findReplacementLogo) {
        const logoResized = new EdgeResizer(
          findReplacementLogo.url
        ).scaleToHeight(obj.height * obj.scaleY);

        const { width, height } = await getImageDimensionsFromUrl(logoResized);

        const center = getObjectCenterCoordinates(obj);

        obj.scaleToHeight(obj.height);
        obj.left = center.x - width / 2;
        obj.top = center.y - height / 2;

        await changeImageSrc(obj, logoResized);
      }
    }
  }
  window.canvas.renderAll();
};
